import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  inject,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AuthorizationModule, RolesPipe } from '@wilson/authorization';
import { FeatureFlagsModule } from '@wilson/feature-flags';
import { Shift } from '@wilson/interfaces';
import { ShiftsActionsMenuHelperService } from '@wilson/non-domain-specific/shift-common-actions';
import { MAX_SELECTABLE_SHIFTS_FOR_ADDING_ATTACHMENTS } from '@wilson/non-domain-specific/shift-helpers/core';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';

@Component({
  selector: 'wilson-add-shift-report-attachments-multi-select-shifts-button',
  imports: [
    NzButtonModule,
    TranslateModule,
    FeatureFlagsModule,
    AuthorizationModule,
    NzTooltipModule,
  ],
  templateUrl:
    './add-shift-report-attachments-multi-select-shifts-button.component.html',
  styleUrl:
    './add-shift-report-attachments-multi-select-shifts-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [ShiftsActionsMenuHelperService],
})
export class AddShiftReportAttachmentsMultiSelectShiftsButtonComponent {
  rolesPipe = inject(RolesPipe);
  private readonly shiftsActionsMenuHelperService = inject(
    ShiftsActionsMenuHelperService,
  );

  @Input({ required: true }) selectedShifts!: (Shift & { id: string })[];
  @Input() isOperationOnGoing = false;
  @Output() addOperationTriggered = new EventEmitter();

  protected MAX_SELECTABLE_SHIFT_MODAL_ATTACHMENTS =
    MAX_SELECTABLE_SHIFTS_FOR_ADDING_ATTACHMENTS;

  async addShiftReportAttachments(): Promise<void> {
    this.addOperationTriggered.emit(true);
    await this.shiftsActionsMenuHelperService.addShiftReports(
      this.selectedShifts.map((shift) => shift.id),
    );
    this.addOperationTriggered.emit(false);
  }
}
